<template>
  <v-app>
     <!-- //////////////////////////////////////////////////////////////suggested bad ddresses dialog/////////////////////////////////////////// -->
      

        <v-row v-if="showmain">
         <v-col>
            <v-row justify="center">
                        <v-card
                            outlined
                            elevation="12"
                            color="teal lighten-5"
                            class="ma-6"
                            max-width="800"
                            min-width="600"
                        >
                        <v-card-title>
                          <v-row justify="center">
                          Address Jurisdiction Checker
                          </v-row>  
                        </v-card-title>
                            <v-divider class="ma-0"></v-divider>
                            <v-card-text>
                               <v-row>
                                <v-col>
                                <v-row justify="center">
                                  <h3>(click on an address in the results to see the address on a map)</h3>
                                </v-row>
                                <v-row>
                                  <v-text-field @input="precheckaddress(add)" class="mt-6 mx-6" v-model="add" filled dense outlined persistent-placeholder="" label="Address"></v-text-field>
                                </v-row>
                                <v-row>
                                    <v-divider class="ma-4"></v-divider>
                                </v-row>
                                    <v-row >
                                        <v-col cols="12">
                                          <v-expand-transition>
                                            <v-sheet elevation="24">
                                                <v-row justify="center">
                                                    <v-progress-circular indeterminate v-if="startcircle" color="primary"></v-progress-circular>
                                                </v-row>
                                                <v-expand-transition>
                                                <v-sheet width="100%" v-if="addguesses.length>0">
                                                   <table  rules="all" width="100%">
                                                        <tr >
                                                          <td><b><center>Address</center></b></td>
                                                          <td><b><center>City</center></b></td>
                                                          <td><b><center>Jurisdiction</center></b></td>
                                                          <td><b><center>District</center></b></td>
                                                        </tr>
                                                        <tr v-for="x in addguesses" :key="x.attributes.SITUS_ID" :class="x.attributes.rowcolor" @click="useaddress(x)" >
                                                            <td class="ma-2">&nbsp;{{x.attributes.FULL_ADDR}}</td>
                                                            <td class="ma-2">&nbsp;{{x.attributes.CITY}}</td>
                                                            <td class="ml-3">&nbsp;{{x.attributes.JURISDICT}}</td>
                                                            <td class="ml-3">&nbsp;{{x.attributes.district}}</td>
                                                        </tr>
                                                        <tr><td cols='3'></td></tr>
                                                    </table>
                                                </v-sheet>
                                                </v-expand-transition>
                                                <v-row class="ma-2" justify="center" ><h3>{{msg}}</h3></v-row>
                                            </v-sheet>
                                          </v-expand-transition>
                                        </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                            </v-card-text>
                  </v-card>
              </v-row>
          </v-col>
        </v-row>

        <div v-if="showmap" style="height:100%">
          <center>
          <v-btn-toggle
          v-model="toggle_exclusive"
          rounded
          class="ma-2"
          >
            <v-btn  color="success lighten-1" @click="url=url2">Imagery</v-btn>
            <v-btn  color="success" @click="url=url1">Street Map1</v-btn>
            <v-btn  color="success lighten-1" @click="url=url3">Street Map2</v-btn>
            <v-btn  color="success" @click="url=url4">Simple</v-btn>
            <v-btn dark v-if="cl"  color="success darken-2" @click="cl=false">City Limits On</v-btn>
            <v-btn dark v-if="!cl" color="warning" @click="cl=true">City Limits Off</v-btn>
            <!--
            <v-btn dark v-if="cd"  color="success darken-2" @click="cd=false">Council Districts On</v-btn>
            <v-btn dark v-if="!cd" color="warning" @click="cd=true">Council Districts Off</v-btn>
            -->
            <v-btn color="error" @click="exit">EXIT</v-btn>
          </v-btn-toggle>
          </center>
          <v-row class="ma-4">
            Jurisdiction: {{jurisdiction}}<br/>
            Address: {{address}}
          </v-row>
          
        <l-map ref="myMap" style="height: 100%" :zoom="zoom" :center=[y,x]>
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-tile-layer v-if="cl" :url="url5" :attribution="attribution"></l-tile-layer>
            <l-tile-layer v-if="cd" :url="url6" :attribution="attribution"></l-tile-layer>
            <l-marker :lat-lng=[y,x]>test</l-marker>
          </l-map>
        </div> 
          
       
        
        
  </v-app>
</template>

<script>
import 'leaflet/dist/leaflet.css';
import axios from 'axios'

import { Icon } from 'leaflet';
//set the icon that will be used (no icon will be used for the marker without this)
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

//import L from 'leaflet';  only needed to directly access leaflet
// ////// for info goto https://vue2-leaflet.netlify.app/


import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';

export default {
  name: 'Home',
  data(){
        return{
    address:'',
    name:'',
    toggle_exclusive:'',
    showmap:false,
    showmain:true,
    add:'',
    cl:true,
    cd:false,
    addguesses:[],
    dialogsa:false,
    startcircle:false,
    urlcheck:"https://arcgis.bremertonwa.gov/arcgis/rest/services/Basemaps/Simple_Basemap/MapServer/0/query",
    x:-122.6,
    y:47.6,
    jurisdiction:'',
    message:'',
    msg:'',
    url:'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    url1:'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    url2:'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    url3:'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
    url4:'https://tileserver.memomaps.de/tilegen/{z}/{x}/{y}.png',
    url5:'https://tiles.arcgis.com/tiles/m9zYNmX49ddkBsgd/arcgis/rest/services/CityLimits/MapServer/tile/{z}/{y}/{x}?cacheKey=858ccfae067eaeac',
    url6:'https://services3.arcgis.com/m9zYNmX49ddkBsgd/arcgis/rest/services/Council_Districts/MapServer/tile/{z}/{y}/{x}',
    url7:'https://services3.arcgis.com/m9zYNmX49ddkBsgd/arcgis/rest/services/Council_Districts_labels_view/FeatureServer/1/query',
    attribution:'City of Bremerton',
    zoom: 15,
  }},
  components:{
    LMap,
    LTileLayer,
    LMarker,
  },
  mounted() {
    window.console.log("mounted");
    this.name = this.$route.query.a;
    if(this.name){
      this.precheckaddress(this.name);
    }
  },
  methods:{
    useaddress(x){
      this.url=this.url1;
      this.x=x.geometry.x;
      this.y=x.geometry.y;
      this.showmap=true;
      this.showmain=false;
      this.jurisdiction=x.attributes.JURISDICT;
      this.address=x.attributes.FULL_ADDR + " " + x.attributes.CITY + " " + x.attributes.STATE +", "+x.attributes.ZIP_CODE;
            if(x.attributes.rowcolor=='rowbad'){
                this.message="Not our problem";
            }else{
              this.message="We need to take care of this";
            }
        },
    precheckaddress(x){
            this.startcircle=true;
            this.checkaddress(x);
        },
    
    checkaddress(x){
            this.msg="";
            this.addrprikey=x.prikey;
            this.restofaddress=false;
            let y=x;
            if(y.length<4){
                this.dialogsa=false;
                this.startcircle=false;
                return;
            }
            let yA=y.split(" ");
            let w='1=1 ';
            for(let z=0;z<yA.length;z++){
                w=w+" and FULL_ADDR like '%"+yA[z]+"%'";
            }
            
            let thisvue = this;
            let url = this.urlcheck;
            const params = new URLSearchParams();
            var d=[];

            params.append('where',w);
            params.append('timeRelation', 'esriTimeRelationOverlaps');
            params.append('geometryType','esriGeometryEnvelope');
            params.append('spatialRel','esriSpatialRelIntersects');
            params.append('units','esriSRUnit_Foot');
            params.append('outFields','*');
            params.append('outSR','4326');
            params.append('returnGeometry','true');
            params.append('returnTrueCurves','false');
            params.append('returnIdsOnly','false');
            params.append('returnCountOnly','false');
            params.append('returnZ','false');
            params.append('returnM','false');
            params.append('returnDistinctValues','false');
            params.append('returnExtentOnly','false');
            params.append('sqlFormat','none');
            params.append('featureEncoding','esriDefault');
            params.append('resultRecordCount','100');
            params.append('f','pjson');
              
                        
            axios({
                method:"post",
                url:url,
                data:params
            })
            .then(function(response){
              d=response.data.features;
              thisvue.msg=d.length+" results";

                if(response.data.exceededTransferLimit){
                  thisvue.addguesses={};
                  thisvue.msg="Too many results to show";
                  thisvue.startcircle=false;
                }else{
                  thisvue.msg="No results for this address";
                    for(let i=0;i<d.length;i++){
                      d[i].attributes.district='';
                      thisvue.msg=d.length+" results";
                        if(d[i].attributes.JURISDICT=="BR"){
                        d[i].attributes.JURISDICT="Bremerton";
                        d[i].attributes.rowcolor="rowgood";
                        let x=d[i].geometry.x;
                        let y=d[i].geometry.y;
                        //////
                        //time to get the council district number
                        //////
                        let url = thisvue.url7;
                        const params = new URLSearchParams();

                        //params.append('where',w);
                        params.append('geometry','{y:'+y+',x:'+x+'}');
                        //params.append('timeRelation', 'esriTimeRelationOverlaps');
                        params.append('geometryType','esriGeometryPoint');
                        params.append('spatialRel','esriSpatialRelIntersects');
                        //params.append('units','esriSRUnit_Foot');
                        params.append('outFields','*');
                        params.append('inSR','4326');
                        params.append('outSR','4326');
                        params.append('returnGeometry','true');
                        params.append('returnTrueCurves','false');
                        params.append('returnIdsOnly','false');
                        params.append('returnCountOnly','false');
                        params.append('returnZ','false');
                        params.append('returnM','false');
                        params.append('returnDistinctValues','false');
                        params.append('returnExtentOnly','false');
                        params.append('sqlFormat','none');
                        params.append('featureEncoding','esriDefault');
                        params.append('resultRecordCount','100');
                        params.append('f','pjson');
                          
                                    
                        axios({
                            method:"post",
                            url:url,
                            data:params
                        })
                        .then(function(response){  
                          let c=response.data.features[0].attributes.COUNCIL;
                          d[i].attributes.district=c;
                          
                        });

                        window.console.log(response.data.features[i]);

                        }else{
                            d[i].attributes.rowcolor="rowbad";
                        }

                        if(d[i].attributes.JURISDICT=="BI"){
                        d[i].attributes.JURISDICT="Bainbridge";
                        }

                        if(d[i].attributes.JURISDICT=="CO"){
                        d[i].attributes.JURISDICT="County";
                        }
                        if(d[i].attributes.JURISDICT=="PO"){
                        d[i].attributes.JURISDICT="Port Orchard";
                        }
                        if(d[i].attributes.JURISDICT=="PB"){
                        d[i].attributes.JURISDICT="Poulsbo";
                        }
                    }

                
                thisvue.addguesses=d;
                thisvue.dialogsa=true;
                thisvue.startcircle=false;
                }
             
            }).then(function(){
              if(thisvue.name){
                let x=thisvue.addguesses[0];
                window.console.log(x);
                //thisvue.useaddress(x);
              }
            });
        },
        exit(){
          window.console.log("exiting");
          this.showmap=false;
          this.showmain=true;
        }
  },
}
</script>


